// Vuex transaction module actions
import { API } from "@/config";
import { FILL_LIST } from "./mutations-types";
import { FILL_AGENTS } from "./mutations-types";

export default {
  async getAgentsBelongsToUserList({ commit }) {
    try {
      const { records, total } = (await API.get("/project/user/agent/getList")).data.data;
      commit(FILL_LIST, { records, total });
    } catch (err) {
      console.log(err);
    }
  },
  async getAgentsList({ commit }, projects) {
    try {
      const params = {
      filtering_criteria: [],
      page: -1,
      project: projects
    };
      const { records, total } = (await API.get("/project/agent/getList", { params })).data.data;
      commit(FILL_AGENTS, { records, total });
    }
    catch (err) {
      console.log(err);
    }
    
  },
  async forwardCall(context, params) {
    try {
      return (await API.patch("/agent/forwardCall", { ...params })).data;
    } catch (err) {
      console.log(err);
      return 0;
    }
  },
  async setStatus(context, params) {
    try {
      await API.patch("/project/agent/setStatus", { ...params });
    } catch (err) {
      console.log(err);
    }
  },
  async makeCall(context, data) {
    try {
      const params = {
        agent: data.agent,
        number_b: data.number_b,
        connection: data.uuid,
      };
      return await API.post("/agent/makeCall", { ...params });
    } catch (err) {
      console.log(err);
      return 0;
    }
  },
  async stopCalling(context, massdialUuid) {
    try {
      const params = {
        massdial_numbers_uuid: massdialUuid
      };
      return await API.patch("/agent/stopCalling", params);
    } catch (err) {
      console.log(err);
      return 0;
    }
  },
  async unlockAgent(context, params) {
    try {
      return (await API.patch("/agent/unlock", { ...params })).data;
    } catch (err) {
      console.log(err);
      return 0;
    }
  }
};
